// A row of questions the athlete can tap (v2/suggestions.js decides which).
import React from 'react';
import { Chip } from '../ds';
import { cn } from '../../lib/utils';

export default function SuggestionChips({ chips, onPick, disabled = false, className }) {
  if (!chips?.length) return null;
  return (
    <div className={cn('flex flex-wrap gap-1.5', className)} role="group" aria-label="Suggested questions">
      {chips.map((c) => (
        <Chip key={c.text} title={c.why || undefined} onClick={() => onPick(c)} disabled={disabled}
          className="h-auto min-h-9 whitespace-normal py-1.5 text-left disabled:opacity-50">{c.text}</Chip>
      ))}
    </div>
  );
}
